import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

export const linkVariants = cva(
    `sph-link cursor-pointer rounded-xs outline-none focus-visible:ring-ring/30 focus-visible:ring-[3px]`,
    {
        variants: {
            variant: {
                default: 'text-primary hover:text-accent-dark',
                inherit: 'text-inherit',
                muted: 'text-muted-foreground hover:text-copy',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);
export type LinkVariants = VariantProps<typeof linkVariants>;
